<div class="modal-full-page-body">
  <h1 class="title">Create Fund On Hold</h1>

  <div class="form" [class.form-with-error]="formSubmitError">
    <div class="rkt-form" style="margin-bottom: 20px">
      <div class="rkt-form-row">
        <div class="rkt-form-field" [class.has-error]="isAmountInvalid">
          <div class="rkt-form-label">
            <label for="amountInput">Amount <span class="asterisk">*</span></label>
          </div>
          <input
            id="amountInput"
            type="text"
            class="rkt-form-input"
            [class.is-invalid]="isAmountInvalid"
            [formControl]="amountField"
            [prefix]="'$ '"
            mask="separator.2"
            thousandSeparator=","
            [placeholder]="'$0.00'"
            (ngModelChange)="onAmountChange($event)"
            (blur)="onAmountBlur()"
          />
          @if (isAmountInvalid) {
            <div class="rkt-form-field-invalid-feedback">Amount must be greater than $0.00</div>
          }
        </div>
      </div>
    </div>

    <form [formGroup]="createForm">
      <rkt-form [form]="createForm" [fields]="createFields" [model]="formModel"></rkt-form>
    </form>
  </div>

  @if (formSubmitError) {
    <div class="error-container">
      <div class="separator"></div>
      <div class="details-page-edit-form-error">{{ formSubmitError }}</div>
    </div>
  }

  <div class="footer">
    <div class="separator"></div>
    <div class="buttons">
      <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>

      <button rktButton type="submit" (click)="onSubmit()" [title]="'Create Fund On Hold'" [disabled]="isFormInvalid || isLoading">
        Create
      </button>
    </div>
  </div>
</div>
